const EmptyDashboardState = () => {
    return (
        <div
            className="empty-dashboard d-flex flex-column align-items-center justify-content-center"
            style={{ height: "100%" }}
        >
            <div style={{ fontSize: "48px" }}>📊</div>
            <h5 className="mt-3">No widgets added yet</h5>
            <p className="text-muted text-center mt-1">
                Add Insight or other menus from the left panel<br />
                to start building your dashboard.
            </p>
        </div>
    );
};

export default EmptyDashboardState;
